import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTopicsListQuery } from '../../../store/chatbox/chatboxApi';
import { useGetCurrentUserQuery } from '../../../store/user/userApi';
import { useTheme } from '../../../utils/theme-context';
import { ITopics } from '../../../interfaces/chats/IChatResponse';

const ChatHistory = () => {
	const { theme } = useTheme();
	const [page, setPage] = useState(1);
	const [history, setHistory] = useState<ITopics[]>([])
  
	const { data: userInfo, isLoading } = useGetCurrentUserQuery();
	const { data, isFetching } = useTopicsListQuery(
	  { type: 'HISTORY', userId: userInfo?.id || '', page, limit: 20 },

	  { skip: !userInfo?.id }
	);

	useEffect(()=>{
		if (data) {
			setHistory(history ? [...history, ...data.elements] : data.elements);
		}
	},[data])
  
	return (
	  <>
		{(data?.elements.length === 0 && !isLoading) && <p>No chats on history</p>}
  
		{history.map(chat => (
		  <NavLink
			key={chat._id}
			className="w-full mb-2 flex flex-row items-center border border-gray-100 dark:border-primary-darkMode text-gray-900 text-sm p-2 hover:opacity-80"
			to={`/chat/${chat._id}`}
		  >
			<img
			  alt="chat"
			  className="mr-2 object-contain w-[20px]"
			  src={theme === 'dark'
				? '/svg/icons/chat-icon-white.svg'
				: '/svg/icons/chat.svg'
			  }
			/>
			<span className="dark:text-primary-darkMode">{chat.name}</span>
		  </NavLink>
		))}
  
		{data?.page.hasNextPage && (
		  <button
			disabled={isFetching}
			className="mt-4 flex flex-wrap text-black justify-center underline w-full mb-12"
			onClick={() => setPage(prev => prev + 1)}
		  >
			{isFetching ? 'Loading...' : 'Load more'}
		  </button>
		)}
	  </>
	);
  };
  
  export default ChatHistory;